/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { equal } from '@ember/object/computed';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';

const EDITOR_TYPES = {
  richText: 'wysiwyg',
  code: 'html',
};

interface DraftEditorControlsArgs {
  editorName: 'wysiwyg' | 'html';
  toggleEditor: () => unknown;
  disabled: boolean;
}

export default class DraftEditorControls extends Component<DraftEditorControlsArgs> {
  @service auth!: AuthService;

  @equal('args.editorName', EDITOR_TYPES.richText) isRichText!: boolean;
  @equal('args.editorName', EDITOR_TYPES.code) isCode!: boolean;

  @tracked showSwitchModal = false;
  @tracked showLiquidGuide = false;

  @action
  setEditor(editor: 'wysiwyg' | 'html') {
    if (this.args.editorName === editor) {
      return;
    }

    this.args.toggleEditor();
    this.showSwitchModal = false;
  }
}
